import { useMutation, useQueryClient } from 'react-query';

import { ServerStateKeysEnum } from 'reactQuery/constants';
import { productService } from 'services';
import { ToggleFavourite } from 'types';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useToggleFavourites = () => {
  const i18n = useI18n();
  const queryClient = useQueryClient();
  return useMutation(
    ({ variantId }: ToggleFavourite) => {
      return productService.toggleFavouriteProduct(parseInt(variantId));
    },
    {
      onSuccess: (data, variables, context) => {
        const currentFavourites = queryClient.getQueryData<string[]>(
          ServerStateKeysEnum.favouriteProductIds
        );

        let newFavourites: string[];

        if (currentFavourites) {
          if (data.isFavourite) {
            currentFavourites.push(variables.variantId);
            newFavourites = currentFavourites;
            displayNotification(i18n['Added to Favourites!']);
          } else {
            newFavourites = currentFavourites.filter(id => {
              return variables.variantId.toString() !== id.toString();
            });
            displayNotification(i18n['Removed from Favourites!']);
          }

          queryClient.setQueriesData(
            [ServerStateKeysEnum.favouriteProductIds],
            newFavourites
          );
        }
      },
      onError: (err: string) => {
        const errMessage = err ?? i18n['Failed to add to Favourites!'];
        displayNotification(errMessage, 'danger');
      },
    }
  );
};
